export const PROMOTION_IMAGE_MAX_BYTES = 512 * 1024;
export const PROMOTION_IMAGE_MIME_TYPES = [
    "image/jpeg",
    "image/png",
    "image/webp",
];
/** Public API path prefix served from content host. */
export const PUBLIC_UPLOAD_PATH_PREFIX = "/uploads";
export function isPublicUploadPath(path) {
    if (!path)
        return false;
    return path.startsWith(`${PUBLIC_UPLOAD_PATH_PREFIX}/`) && !path.includes("..");
}
/** True when path is under `/uploads/{organizationId}/...` (C1B asset isolation). */
export function isOrganizationUploadPath(path, organizationId) {
    if (!path || !organizationId || path.includes(".."))
        return false;
    const prefix = `${PUBLIC_UPLOAD_PATH_PREFIX}/${organizationId}/`;
    return path.startsWith(prefix);
}
export const SPONSORED_IMAGE_PATH_EXT = /\.(jpg|jpeg|png|webp)$/i;
export function isSponsoredCreativeImagePath(path, organizationId) {
    if (!path || !isOrganizationUploadPath(path, organizationId))
        return false;
    return SPONSORED_IMAGE_PATH_EXT.test(path);
}
//# sourceMappingURL=image-upload.js.map